export const RegexPatterns = {
  Name: /^[\w-\s+]+$/,
  Phone: /^(?:(?:\+|00)(41|49)|0)\s?(\d\s?){9,10}$/,
  Email: /^[a-zA-Z0-9]+(?:[._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.[a-zA-Z]{2,4}$/,
  Password: /^(?=.*[A-Z])(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
  EmailScanAndAttach: /^[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,4}(?:\s*;\s*[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,4})*$/,
};
